let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6Pnts")).then(() => parcelRequire('G6p7g'));